import React, { useCallback, useEffect, useState } from 'react';

import { FormBuilderField } from 'api/cms';
import Checkbox from 'components/Checkbox';
import { LegacyInput } from 'components/LegacyInput';
import SelectInput from 'components/SelectInput';
import { trackEvent } from 'utils/analytics';

import { getFormBuilderId } from './getFormBuilderId';

export function FormBuilderBlockField({
  action,
  type,
  name,
  placeholder,
  options,
  required,
  label,
  value: submitValue,
}: FormBuilderField & {
  action: string;
}) {
  const [value, setValue] = useState('');
  const [checked, setChecked] = useState(false);
  const [changed, setChanged] = useState(false);
  const id = getFormBuilderId(name);
  const inputProps = {
    name,
    placeholder,
    required,
    id,
    'data-qa-id': id,
  };
  const trackChange = useCallback(() => {
    trackEvent('CMS Form Edited', {
      action,
      label,
    });
  }, [action, label]);
  useEffect(() => {
    if (changed) {
      trackChange();
    }
  }, [changed, trackChange]);

  const setTextValue = (e) => {
    setValue(e);
    setChanged(true);
  };

  const setSelectValue = (e) => {
    setValue(e);
    trackChange();
  };

  const updateChecked = (e) => {
    setChecked(e);
    trackChange();
  };

  switch (type) {
    case 'SELECT':
      return (
        <SelectInput
          options={[
            {
              value: '',
              label: placeholder || getText('Select One'),
              disabled: true,
            },
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          ].concat(options || [])}
          onChange={setSelectValue}
          value={value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
        />
      );

    case 'CHECKBOX':
      return (
        <Checkbox
          onChange={updateChecked}
          checked={checked}
          value={submitValue}
          label={label}
          large
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
        />
      );

    case 'HIDDEN':
      return <input name={name} value={submitValue} hidden />;

    case 'TEXT':
    case 'EMAIL':
    default:
      return (
        <LegacyInput
          type={type.toLowerCase()}
          changeHandler={setTextValue}
          onFocus={() => setChanged(false)}
          value={value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
        />
      );
  }
}
